/** 图片验证码 **/
<template>
  <div class="BasicInput">
    <div class="revenueWrap top_total_revenue">
      <div class="one_day_revenue each_item_wrap ">
        <div class="revenue_item">
          <div class="flex">
            <img
              class="revenue-icon home-icon"
              src="../../assets/revenue/online_revunue.png"
            >
            <div class="revenue_title">{{ $t('revenue_1') }}</div>
          </div>
          <img
              class="revenue-icon home-icon cursor"
              src="../../assets/revenue/exchange.png"
              @click="switchUnit('total')"
          >
        </div>
        <div class="revunue_value" v-if="totalRevenue !== ''">{{totalRevenueVal || 0}} {{isAllBP ? 'BP' : '元'}}</div>
        <div class="revunue_value" v-if="totalRevenue === ''">- {{isAllBP ? 'BP' : '元'}}</div>
      </div>
      <div class="one_day_invite_revenue each_item_wrap">
        <div class="revenue_item">
          <div class="flex">
            <img
              class="revenue-icon home-icon"
              src="../../assets/revenue/online_invite.png"
            >
            <div class="revenue_title">{{ $t('revenue_2') }}
              <el-tooltip class="item" effect="dark" :content=" $t('balance_tips')" placement="top">
                <i class="revenue-icon el-icon-question"></i>
              </el-tooltip>
            </div>
          </div>
          <img
              class="revenue-icon home-icon cursor"
              src="../../assets/revenue/exchange.png"
              @click="switchUnit('balance')"
          >
        </div>
        <div class="revunue_value" v-if="balance !== ''">{{ balanceVal || 0}} {{isBalanceBP ? 'BP' : '元'}}</div>
        <div class="revunue_value" v-if="balance === ''">- {{isBalanceBP ? 'BP' : '元'}}</div>
      </div>
      <div class="total_revenue each_item_wrap">
        <div class="revenue_item">
          <div class="flex">
            <img
              class="revenue-icon home-icon"
              src="../../assets/revenue/person_total_revenue.png"
            >
            <div class="revenue_title">{{ $t('revenue_3')}}
              <el-tooltip class="item" effect="dark" :content="$t('invite_tips')" placement="top">
                <i class="revenue-icon el-icon-question"></i>
              </el-tooltip>
            </div>
          </div>
          <img
              class="revenue-icon home-icon cursor"
              src="../../assets/revenue/exchange.png"
              @click="switchUnit('totalInvite')"
          >
        </div>
        <div class="revunue_value" v-if="totalInvite !== ''">{{totalInviteVal || 0}} {{isTotalInviteBP ? 'BP' : '元'}}</div>
        <div class="revunue_value" v-if="totalInvite === ''">- {{isTotalInviteBP ? 'BP' : '元'}}</div>
      </div>
    </div>
    <div class="revenueWrap">
      <div class="one_day_invite_revenue each_item_wrap">
        <div class="revenue_item">
          <div class="flex">
            <img
              class="revenue-icon home-icon"
              src="../../assets/revenue/online_invite.png"
            >
            <div class="revenue_title">{{ $t('revenue_5') }}
              <el-tooltip class="item" effect="dark" :content=" $t('network_tips')" placement="top">
                <i class="revenue-icon el-icon-question"></i>
              </el-tooltip>
            </div>
          </div>
          <img
              class="revenue-icon home-icon cursor"
              src="../../assets/revenue/exchange.png"
              @click="switchUnit('totalNetRevenue')"
          >
        </div>
        <div class="revunue_value" v-if="totalNetRevenue !== ''">{{totalNetRevenueVal || 0}} {{isTotalNetRevenueBP ? 'BP' : '元'}}</div>
        <div class="revunue_value" v-if="totalNetRevenue === ''">- {{isTotalNetRevenueBP ? 'BP' : '元'}}</div>
      </div>
      <div class="total_revenue each_item_wrap">
        <div class="revenue_item">
          <div class="flex">
            <img
              class="revenue-icon home-icon"
              src="../../assets/revenue/person_total_revenue.png"
            >
            <div class="revenue_title">{{ $t('revenue_6')}}
              <el-tooltip class="item" effect="dark" :content=" $t('calculate_tops')" placement="top">
                <i class="revenue-icon el-icon-question"></i>
              </el-tooltip>
            </div>
          </div>
          <img
              class="revenue-icon home-icon cursor"
              src="../../assets/revenue/exchange.png"
              @click="switchUnit('totalCalculate')"
          >
        </div>
        <div class="revunue_value" v-if="totalCalculate !== ''">{{totalCalculateVal || 0}} {{isTotalCalculateBP ? 'BP' : '元'}}</div>
        <div class="revunue_value" v-if="totalCalculate === ''">- {{isTotalCalculateBP ? 'BP' : '元'}}</div>
      </div>
      <div class="one_day_revenue each_item_wrap">
        <div class="revenue_item">
          <div class="flex">
            <img
              class="revenue-icon home-icon"
              src="../../assets/revenue/person_total_revenue.png"
            >
            <div class="revenue_title">{{ $t('revenue_7')}}
              <el-tooltip class="item" effect="dark" :content=" $t('activity_tips')" placement="top">
                <i class="revenue-icon el-icon-question"></i>
              </el-tooltip>
            </div>
          </div>
          <img
              class="revenue-icon home-icon cursor"
              src="../../assets/revenue/exchange.png"
              @click="switchUnit('totalActivity')"
          >
        </div>
        <div class="revunue_value" v-if="totalActivity !== ''">{{totalActivity || 0}} {{isTotalActivityBP ? 'BP' : '元'}}</div>
        <div class="revunue_value" v-else>- {{isTotalActivityBP ? 'BP' : '元'}}</div>
        
        <!-- <div class="revenue_item"> -->
          <!-- <img
            class="revenue-icon home-icon"
            src="../../assets/revenue/online_revunue.png"
          >
          <div class="revenue_title">{{ $t('revenue_4') }}
            <el-tooltip class="item" effect="dark" :content=" $t('online_tips')" placement="top">
              <i class="revenue-icon el-icon-question"></i>
            </el-tooltip>
          </div>
        </div>
        <div class="revunue_value" v-if="totalOnlineRevenue !== ''">{{totalOnlineRevenue || 0}} BP</div>
        <div class="revunue_value" v-if="totalOnlineRevenue === ''">- BP</div> -->
      </div>
    </div>
  </div>
</template>


<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: "RevenueContent",
  computed: mapState({
    balance: state => state.revenue.balance || '',
    totalInvite: state => state.revenue.totalInvite || '',
    totalNetRevenue: state => state.revenue.totalNetRevenue || '',
    totalOnlineRevenue: state => state.revenue.totalOnlineRevenue || '',
    totalRevenue: state => state.revenue.totalRevenue || '',
    totalCalculate: state => state.revenue.totalCalculate || ''
  }),
  data() {
    return{
      isAllBP: true,
      isBalanceBP: true,
      isTotalInviteBP: true,
      isTotalNetRevenueBP: true,
      isTotalCalculateBP: true,
      isTotalActivityBP: true,

      
      totalRevenueVal: '',
      balanceVal: '',
      totalInviteVal:'',
      totalNetRevenueVal: '',
      totalCalculateVal: '',
      totalActivity: '',
    }
  },
  methods: {
    ...mapActions(["getAllRevenue", "getRevenueList", "getActivityAllRevenue"]),
    switchUnit(type) {
      if (type === 'total') {
        this.isAllBP = !this.isAllBP;
        this.totalRevenueVal = this.isAllBP ? this.RMBToBP(this.totalRevenueVal) : this.BPToRMB(this.totalRevenueVal);
      } else if(type === 'balance') {
        this.isBalanceBP = !this.isBalanceBP;
        this.balanceVal = this.isBalanceBP ? this.RMBToBP(this.balanceVal) : this.BPToRMB(this.balanceVal);
      } else if(type === 'totalInvite') {
        this.isTotalInviteBP = !this.isTotalInviteBP;
        this.totalInviteVal = this.isTotalInviteBP ? this.RMBToBP(this.totalInviteVal) : this.BPToRMB(this.totalInviteVal);
      } else if(type === 'totalNetRevenue') {
        this.isTotalNetRevenueBP = !this.isTotalNetRevenueBP;
        this.totalNetRevenueVal = this.isTotalNetRevenueBP ? this.RMBToBP(this.totalNetRevenueVal) : this.BPToRMB(this.totalNetRevenueVal);
      } else if(type === 'totalCalculate') {
        this.isTotalCalculateBP = !this.isTotalCalculateBP;
        this.totalCalculateVal = this.isTotalCalculateBP ? this.RMBToBP(this.totalCalculateVal) : this.BPToRMB(this.totalCalculateVal);
      } else if(type === 'totalActivity') {
        this.isTotalActivityBP = !this.isTotalActivityBP;
        this.totalActivity = this.isTotalActivityBP ? this.RMBToBP(this.totalActivity) : this.BPToRMB(this.totalActivity);
      }
    },
    BPToRMB(val) {
        return (val * 0.0029).toFixed(2);
    },
    RMBToBP(val) {
        return (val / 0.0029).toFixed(2);
    },
  },
  created() {
    this.getAllRevenue().then((revenueRes)=>{
      if(revenueRes.code == 200) {
        this.totalRevenueVal = revenueRes.ret.totalRevenue;
        this.balanceVal = revenueRes.ret.balance;
        this.totalInviteVal = revenueRes.ret.totalInvite;
        this.totalNetRevenueVal = revenueRes.ret.totalNetRevenue;
        this.totalCalculateVal = revenueRes.ret.totalCalculate;
      } else {
        this.totalRevenueVal = '';
        this.balanceVal = '';
        this.totalInviteVal = '';
        this.totalNetRevenueVal = '';
        this.totalCalculateVal = '';
      }
    });
    this.getActivityAllRevenue().then((res)=>{
      if(res && res.code === 200 ) {
        this.totalActivity = res.rewardSummary.bp;
      } else {
        this.totalActivity = '';
      }
    })
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="stylus">
.flex {
  display: flex;
}
.cursor {
  cursor: pointer;
}
.is-mobile {
  .revenueWrap {
    display flex
    flex-wrap wrap
    justify-content flex-start
    >div{
      width 100%
      box-sizing border-box
    }
  }
}
.revenueWrap {
  display: flex;
  justify-content: space-between;
}

.revenue_item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

justify-content center, .revenue-icon {
  margin: 0px 8px 0 0;
  width: 14px;
  height: 14px;
  padding-top: 4px;
}

.revenue_title {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  color: #343739;
}

.revunue_value {
  text-align: left;
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #65686A;
  margin: 19px 0 10px 20px;
}

.top_total_revenue .each_item_wrap {
  border-bottom: 1px solid #e3e3e7;
}

.each_item_wrap {
  width: 33%;
  padding: 20px;
  border-right: 1px solid #e3e3e7;
}
.revenue-icon{
  color: #999;
}
</style>

<i18n>
{
  "en": {
		"revenue_1": "Account Total Revenue",
		"revenue_2": "Account Balance",
		"revenue_3": "Cumulative Invitation Bonus",
		"revenue_4": "Cumulative Online Revenue",
		"revenue_5": "Cumulative Network Task Revenue",
    "revenue_6": "Cumulative Computing Task Revenue",
    "revenue_7": "Account Activity Total Revenue",
    "total_tips": "Total Revenue is sum of invitation rewards, online task revenue and computing task revenue.",
    "balance_tips": "Account Balance: the withdrawable BP amount of this account ( Please be noted that there is a little difference with the total revenue due to the latency for the data updated into the blockchain)",
    "invite_tips": " Cumulative Invitation Bonus: the cumulative bonus from the revenue of the accounts, which registered via the invitation link of this account.",
    "online_tips": "Cumulative Online Revenue: the total revenue for keeping online of all the devices bound to this account. (Separated to show from Jan. 5, 2019, and shown in the online task revenue before)",
    "network_tips": "Cumulative Online Task Revenue: the total revenue for completing online tasks of all the devices bound to this account.",
    "calculate_tops": "Cumulative Computing Task Revenue: the total revenue for completing computing tasks of all the devices bound to this account.",
    "activity_tips": "Account Activity Total Revenue: Cumulative revenue from additional revenue earned by current account activities."
  },
  "zn": {
		"revenue_1": "账号累计收益",
		"revenue_2": "账号余额",
		"revenue_3": "账号累计邀请奖励",
		"revenue_4": "账号累计在线收益",
		"revenue_5": "账号累计网络任务收益",
    "revenue_6": "账号累计计算任务收益",
    "revenue_7":"账号累计活动收益",
    "total_tips": "账号累计总收益：账号累计收益为邀请奖励、网络任务收益、计算任务收益相加的总和。",
    "balance_tips": "账号余额：账号余额表示账号当前可提现BP的数量（由于数据上链存在延迟，此处显示的数据会与总收益有些许差异）.",
    "invite_tips": "账号累计邀请奖励：通过当前账号邀请链接注册的账号收益所带来的累计奖励。",
    "online_tips": "账号累计在线收益：当前账号绑定的所有硬件保持在线所获得的总收益。（从2019年1月5日开始计算，此前合并于网络任务收益。）",
    "network_tips": "账号累计网络任务收益：当前账号绑定的所有硬件完成网络任务所获得的总收益。",
    "calculate_tops": "账号累计计算任务收益：当前账号绑定的所有硬件完成计算任务所获得的总收益。",
    "activity_tips": "账号累计活动收益：当前账号通过活动获取的额外收益所带来的累计收益。"
  }
}
</i18n>


